import React, { useState, useEffect } from 'react';
import { Snackbar, Button, Typography } from '@material-ui/core';
import { isStandalone } from '../../utils/pwaInstall';

const PWA_UPDATE_EVENT = 'pwa-update-available';
const PWA_SW_WAITING_EVENT = 'pwa-sw-waiting';

/**
 * Banner shown when a new app version is available (version.json) or when
 * a new service worker is waiting. Only shown in PWA/standalone (mobile),
 * not on desktop browser.
 */
const PwaUpdateBanner = () => {
  const [open, setOpen] = useState(false);
  const [source, setSource] = useState(null); // 'version' | 'sw'

  useEffect(() => {
    const onUpdate = () => {
      if (!isStandalone()) return;
      setSource('version');
      setOpen(true);
    };
    const onSwWaiting = () => {
      if (!isStandalone()) return;
      setSource('sw');
      setOpen(true);
    };

    window.addEventListener(PWA_UPDATE_EVENT, onUpdate);
    window.addEventListener(PWA_SW_WAITING_EVENT, onSwWaiting);
    return () => {
      window.removeEventListener(PWA_UPDATE_EVENT, onUpdate);
      window.removeEventListener(PWA_SW_WAITING_EVENT, onSwWaiting);
    };
  }, []);

  const handleUpdateNow = () => {
    setOpen(false);
    if (source === 'sw' && window.__swRegistration__?.waiting) {
      window.__swRegistration__.waiting.postMessage({ type: 'SKIP_WAITING' });
      return;
    }
    if (typeof window.applyPwaUpdate === 'function') {
      window.applyPwaUpdate();
    }
  };

  const handleDismiss = () => setOpen(false);

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      style={{ top: 24 }}
    >
      <div
        style={{
          background: '#1e293b',
          color: '#fff',
          padding: '12px 16px',
          borderRadius: 8,
          display: 'flex',
          alignItems: 'center',
          gap: 16,
          flexWrap: 'wrap',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        }}
      >
        <Typography style={{ color: '#fff', flex: 1 }}>
          Nova versão disponível. Atualize para continuar com a experiência mais recente.
        </Typography>
        <div style={{ display: 'flex', gap: 8 }}>
          <Button size="small" onClick={handleDismiss} style={{ color: 'rgba(255,255,255,0.8)' }}>
            Depois
          </Button>
          <Button size="small" variant="contained" color="primary" onClick={handleUpdateNow}>
            Atualizar agora
          </Button>
        </div>
      </div>
    </Snackbar>
  );
};

export default PwaUpdateBanner;
export { PWA_UPDATE_EVENT, PWA_SW_WAITING_EVENT };
